import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import PackageIcon from 'dibs-icons/exports/legacy/ShippingPackage.ts';

import { SbSharedPriceTile } from '../SbSharedPriceTile/SbSharedPriceTile.jsx';
import { updateUriRef } from '../../actions/filterActions.js';
import { FREE_SHIPPING } from '../SbSharedRefineMenu/sbSharedRefineMenuConstants.js';

export function SbRespTradeFreeShippingPromoTileComponent(props) {
    const { applyFreeShippingFilter, position, itemSearch, viewer } = props;

    return (
        <SbSharedPriceTile
            dataTn="priceTile-free-shipping"
            displayName={
                <FormattedMessage
                    id="sb.SbRespTradeFreeShippingPromoTile.title"
                    defaultMessage="Free Shipping"
                />
            }
            hoverMessage={
                <FormattedMessage
                    id="sb.SbRespTradeFreeShippingPromoTile.shopFreeItems"
                    defaultMessage="shop items that ship free to you"
                />
            }
            IconComponent={PackageIcon}
            image="https://a.1stdibscdn.com/dist/adhoc/trade/free-shipping/free-shipping-tile.jpg?height=180"
            isSbUrl={false}
            onClick={() => {
                const filters = viewer?.shippingFilters || [];
                const freeShippingFilter = filters.find(filter => filter?.name === FREE_SHIPPING);
                const freeShippingRegions = freeShippingFilter?.values || [];
                if (freeShippingRegions.length > 0) {
                    applyFreeShippingFilter(freeShippingRegions);
                }
            }}
            promoLabel="Free Shipping"
            position={position}
            itemSearch={itemSearch}
        />
    );
}

SbRespTradeFreeShippingPromoTileComponent.propTypes = {
    applyFreeShippingFilter: PropTypes.func.isRequired,
    currency: PropTypes.string,
    position: PropTypes.number,
    itemSearch: PropTypes.object.isRequired,
    viewer: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
    return {
        applyFreeShippingFilter(filterValues) {
            const filterValue = filterValues?.[0] || {};
            dispatch(updateUriRef({ filterName: FREE_SHIPPING, filterValue }));
        },
    };
}

export const SbRespTradeFreeShippingPromoTile = createFragmentContainer(
    connect(null, mapDispatchToProps)(SbRespTradeFreeShippingPromoTileComponent),
    {
        itemSearch: graphql`
            fragment SbRespTradeFreeShippingPromoTile_itemSearch on ItemSearchQueryConnection {
                ...SbSharedPriceTile_itemSearch
            }
        `,
        viewer: graphql`
            fragment SbRespTradeFreeShippingPromoTile_viewer on Viewer {
                shippingFilters(
                    uriRef: $uriRef
                    zipCode: $userZipCode
                    countryCode: $userCountryCode
                ) @include(if: $isClient) {
                    name
                    values {
                        urlLabel
                        displayName
                        linkReference
                    }
                }
            }
        `,
    }
);
